import { render } from "./PostMedia.vue?vue&type=template&id=2791a960"
import script from "./PostMedia.vue?vue&type=script&lang=js"
export * from "./PostMedia.vue?vue&type=script&lang=js"

import "./PostMedia.vue?vue&type=style&index=0&id=2791a960&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__